<p>
    Gridlock Dash is a frantic puzzle game where the player must keep cars from
    colliding. Make your way through 7 levels, and test your skills in 3 endless
    modes in the struggle to keep the streets safe. I made Gridlock Dash in 2014
    to test out iPad development, but I never ended up publishing it to the App
    Store.
</p>
